import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import * as React from 'react';

const FullWidthField = (props: any) => <Field component={TextField} fullWidth {...props} />;
export default FullWidthField;



// WEBPACK FOOTER //
// ./src/common/FullWidthField/FullWidthField.tsx